import {
  getUserError,
  getUserInfo,
  getUserLoading,
} from "../REDUX/Registration/Registration";
import { togRegModalToFalse } from "../REDUX/RegistrationModalToggle/toggleModal";
import { getUserRequestWithToken } from "../RequestMethod";
import { showToast } from "../utils/Toastify";

export const getUser = async (dispatch) => {
  const token = localStorage.getItem("TimeShoppy");

  if (token) {
    dispatch(getUserLoading());
    try {
      const UserRequestWithToken = getUserRequestWithToken(token);
      const { data } = await UserRequestWithToken.post("auth/verifyToken", {
        mes: "hello",
      });

      if (data.message._id) {
        dispatch(getUserInfo(data.message));
        dispatch(togRegModalToFalse());
        // showToast("Hi!", "success");
        return;
      } else {
        dispatch(getUserError("Error Getting User "));
        // alert("Error Getting User ");
        showToast("Error Getting User!", "error");
      }
    } catch (error) {
      console.error(error, "error me");
      if (error.response.data.message) {
        dispatch(getUserError(error.response.data.message));
        // alert(error.response.data.message);
        showToast(error.response.data.message, "error");
      }
    }
  }
};
